import { useReduxState } from 'hooks';
import { getFileType } from 'lib/files';
import { ApiDownloadButton } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  mimeType?: string;
  name: string;
  showDownloadButton?: boolean;
  style?: React.CSSProperties;
  styleAsButton?: boolean;
  url: string;
}

const FileLink = ({
  mimeType,
  name,
  showDownloadButton = false,
  style,
  styleAsButton,
  url
}: Props) => {
  const { messages, theme } = useReduxState();

  const { icon, iconColor } = getFileType({
    defaultColor: theme.textColor,
    mimeType,
    url
  });

  return (
    <div className="file-link">
      <a
        className="link"
        href={url}
        rel="noopener noreferrer"
        style={{
          ...(styleAsButton
            ? {
                backgroundColor: theme.lightGrey,
                borderRadius: showDownloadButton
                  ? `${theme.buttonBorderRadius} 0 0 ${theme.buttonBorderRadius}`
                  : theme.buttonBorderRadius,
                fontSize: '1.4rem',
                padding: '5px 12px'
              }
            : {}),
          ...style
        }}
        target="_blank"
      >
        <div className="icon">
          <Icon icon={icon} style={{ color: iconColor }} />
        </div>
        <div className="name">{name}</div>
      </a>

      {showDownloadButton ? (
        <ApiDownloadButton
          category="group"
          external={true}
          filename={name}
          icon="download"
          iconStyle={{ fontSize: '1.1rem' }}
          url={url}
          size="small"
          style={{
            // borderLeft: `1px solid ${theme.lightGreyDarkActive}`,
            borderRadius: `0 ${theme.buttonBorderRadius} ${theme.buttonBorderRadius} 0`,
            marginLeft: 1
          }}
          tooltip={messages.commonDownload}
        />
      ) : null}

      <style jsx>{`
        .file-link {
          display: inline-flex;
        }
        .link {
          color: inherit;
          display: inline-flex;
          font-size: 1.5rem;
          font-weight: 600;
          gap: 8px;
          text-decoration: none;
          word-break: break-all;
        }
        .link:focus,
        .link:hover {
          text-decoration: underline;
        }
        .name {
          flex-grow: 1;
        }
      `}</style>
    </div>
  );
};

export default FileLink;
